import { call, put, takeLatest } from 'redux-saga/effects';

import * as emailActions from '../actions/email';
import * as api from '../api/email';

const {
  emailListAll,
  emailListAllSucceeded,
  emailListAllFailed,

  emailAdd,
  emailAddSucceeded,
  emailAddFailed,

  emailGet,
  emailGetSucceeded,
  emailGetFailed,

  emailGetFlows,
  emailGetFlowsSucceeded,
  emailGetFlowsFailed,

  emailDelete,
  emailDeleteSucceeded,
  emailDeleteFailed,

  emailUpdate,
  emailUpdateSucceeded,
  emailUpdateFailed,
} = emailActions.actions;

export const email = [
  takeLatest(
    emailListAll.toString() as any,
    genWithPromise(api.getEmailList, emailListAllSucceeded, emailListAllFailed),
  ),

  takeLatest(
    emailAdd.toString() as any,
    genWithPromise(api.addEmail, emailAddSucceeded, emailAddFailed),
  ),

  takeLatest(
    emailGet.toString() as any,
    genWithPromise(api.getEmail, emailGetSucceeded, emailGetFailed),
  ),

  takeLatest(
    emailDelete.toString() as any,
    genWithPromise(api.deleteEmail, emailDeleteSucceeded, emailDeleteFailed),
  ),

  takeLatest(
    emailUpdate.toString() as any,
    genWithPromise(api.updateEmail, emailUpdateSucceeded, emailUpdateFailed),
  ),

  takeLatest(
    emailGetFlows.toString() as any,
    genWithPromise(api.flowGetAll, emailGetFlowsSucceeded, emailGetFlowsFailed),
  ),
];

function genWithPromise(
  apiAction: (action: any) => any,
  resultSucceededAction: (result: any) => any,
  resultFailedAction: (result: any) => any,
) {
  return function* (action: {
    payload: any;
    meta: { resolve: () => void; reject: () => void };
  }) {
    let result;

    try {
      result = yield call(apiAction, action.payload);
      yield call(action.meta.resolve as any, result);
      yield put(resultSucceededAction(result));
    } catch (exception) {
      console.warn(exception);
      // Something went wrong. We reject the promise.
      yield call(action.meta.reject as any, exception);
      result = exception;
      yield put(resultFailedAction(result));
    }
  };
}
